// extracted by mini-css-extract-plugin
export default {"aboutBannerForms":"AcademicsAndResearch_aboutBannerForms__qTalb","aboutBanner":"AcademicsAndResearch_aboutBanner__trYuc","ViewAllButton":"AcademicsAndResearch_ViewAllButton__spMLD"};